import styled from "styled-components";
import { FormControl, Select } from "@mui/material";
import { deviceSpec } from "breakpoints";

export const StyledSeveritySelect = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  
  // This clears the default border setting, keep this as its a hassle
  fieldset {
    border: none;
  }

  & .MuiSelect-select {
    padding: 5px 10px;
    margin: 5px 10px 5px 5px;
    color: ${({ theme }) => theme.name === "light-theme" 
      ? theme.colors.white
      : theme.colors.textColor};
  }
  
  // The following sets the border and the hover state to the colors we want
  .MuiInputBase-root {
    border-radius: ${({ theme }) => theme.borders.borderRadius} !important;
    background-color: ${({ theme }) => theme.name === "light-theme" 
      ? theme.colors.buttonBackground
      : theme.colors.buttonBackground};
    border: 1px solid ${({ theme }) => theme.name === "light-theme"
      ? theme.colors.buttonBorder
      : theme.colors.lightGreyRgba} !important;
    height: 30px;
  }

  .MuiInputBase-root:hover {
    border: 1px solid ${({ theme }) => theme.name === "light-theme"
      ? theme.colors.buttonBorderHighlight
      : theme.colors.actionButtonColorHvr} !important;
  }

  // Style the dropdown icon
  .MuiSelect-icon {
    color: ${({ theme }) => theme.name === "light-theme"
      ? theme.colors.white
      : theme.colors.textColor};
  }

  // Style the dropdown menu items
  .MuiMenu-paper {
    background-color: ${({ theme }) => theme.name === "light-theme"
      ? theme.colors.sidebarcolor
      : theme.colors.buttonBackground} !important;
    color: ${({ theme }) => theme.colors.white} !important;
    
    .MuiMenuItem-root {
      color: ${({ theme }) => theme.colors.white} !important;
      
      &:hover {
        background-color: ${({ theme }) => theme.name === "light-theme"
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(255, 255, 255, 0.08)'} !important;
      }
      
      &.Mui-selected {
        background-color: ${({ theme }) => theme.name === "light-theme"
          ? 'rgba(255, 255, 255, 0.16)'
          : 'rgba(255, 255, 255, 0.16)'} !important;
      }
    }
  }

  @media ${deviceSpec.isTablet} {
    display: none;
  }
`;

export const SeveritySelectInnerContainer = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
        margin: 0;
        margin-right: 0.5em;
        color: ${({ theme }) => theme.name === "light-theme" 
          ? theme.colors.textColor 
          : theme.colors.textColor};
        font-size: ${({ theme }) => theme.font.h4};
        font-weight: 500;
    }
`;

export const SeveritySelectComponentForm = styled(FormControl)`
    min-width: 120px;
`

export const SeveritySelectComponent = styled(Select)`
    .MuiSelect-select {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        font-weight: 500;
    }
    
    .MuiOutlinedInput-notchedOutline {
        border: none;
    }
    
    // Apply special styling for light theme
    ${({ theme }) => theme.name === "light-theme" && `
        background-color: ${theme.colors.buttonBackground};
        color: ${theme.colors.white};
        
        .MuiSelect-icon {
            color: ${theme.colors.white};
        }
    `}
`;

